<template>
  <v-overlay :value="loading" absolute :opacity="0">
    <div class="overlay-content">
      <v-progress-circular
        indeterminate
        color="grey lighten-1"
        size="48"
      ></v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
export default {
  props: {
    loading: Boolean
  }
}
</script>

<style scoped>
.overlay-content {
  position: fixed;
  top: 185px; /* Adjust this value to move the icon further down if needed */
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999; /* Ensure the overlay is on top */
}
</style>

